import { takeLatest, call, put } from "redux-saga/effects";
import {
  fetchLanguagesRequest,
  fetchLanguagesSuccess,
  fetchLanguagesFailure,
} from "../slices/languageSlice";
import { fetchLanguagesFromAPI } from "../api/languageApi";

function* fetchLanguagesSaga() {
  try {
    const languages = yield call(fetchLanguagesFromAPI);
    yield put(fetchLanguagesSuccess(languages));
  } catch (error) {
    yield put(fetchLanguagesFailure(error.message));
  }
}

export function* watchLanguageSaga() {
  yield takeLatest(fetchLanguagesRequest.type, fetchLanguagesSaga);
}
